import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  statHeader: {
    display: 'flex',
    background: 'rgba(235, 236, 244, 1)',
    padding: '8px',
    marginRight: '10px',
    borderRadius: '10px',
  },
  control: {
    display: 'inline-block',
    '&:not(:last-child)': {
      borderRight: 'dashed 1px rgba(44, 45, 62, 0.3)',
    },
  },
}));
